import { HTMLAttributes } from "react";
import cx from "classnames";

export type ContainerProps = HTMLAttributes<HTMLDivElement>;

export default function Card({
    children,
    className,
    compact,
    ...rest
}: ContainerProps) {
    return (
        <div className={cx("rounded-lg bg-white shadow", className)} {...rest}>
            <div
                className={cx(
                    !compact && "px-4 py-5 sm:p-6",
                    !!compact && "px-2 py-2.5 sm:p-4",
                )}>
                {children}
            </div>
        </div>
    );
}
